// src/utils/auth.js
import { jwtDecode } from "jwt-decode";


export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const decoded = jwtDecode(token);
    const exp = decoded.exp;
    if (!exp) return true;
    return Date.now() >= exp * 1000; // JWT exp está en segundos, Date.now() en milisegundos
  } catch (error) {
    return true; // Si hay error al decodificar, tratamos el token como inválido
  }
};